import CatalogMenu from './CatalogMenu';

export default CatalogMenu;